(function () {
  if (window.acProductImageZoom) return;
  window.acProductImageZoom = true;

  var SCALE = 2.5;
  var DRAG_PX = 8;

  function isProductImage(opener) {
    return (
      opener &&
      opener.classList.contains('product__modal-opener--image') &&
      opener.closest('.product__media-wrapper') &&
      !opener.closest('quick-add-modal')
    );
  }

  function frameOf(opener) {
    return opener.querySelector('.product__media');
  }

  function imgOf(opener) {
    return opener.querySelector('.product__media img');
  }

  function buttonOf(opener) {
    return opener.querySelector('.product__media-toggle');
  }

  function limits(frame) {
    var rect = frame.getBoundingClientRect();
    return {
      rect: rect,
      maxX: (rect.width * (SCALE - 1)) / 2,
      maxY: (rect.height * (SCALE - 1)) / 2,
    };
  }

  function clamp(opener) {
    var img = imgOf(opener);
    var frame = frameOf(opener);
    if (!img || !frame || !opener._pan) return;
    var box = limits(frame);
    opener._pan.x = Math.max(-box.maxX, Math.min(box.maxX, opener._pan.x));
    opener._pan.y = Math.max(-box.maxY, Math.min(box.maxY, opener._pan.y));
    img.style.transform =
      'translate(' + opener._pan.x + 'px, ' + opener._pan.y + 'px) scale(' + SCALE + ')';
  }

  function useMouseFollow(event) {
    if (event && event.pointerType === 'touch') return false;
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  function panToPointer(opener, clientX, clientY) {
    var frame = frameOf(opener);
    if (!frame) return;
    var box = limits(frame);
    if (!box.rect.width || !box.rect.height) return;
    var ox = (clientX - box.rect.left) / box.rect.width;
    var oy = (clientY - box.rect.top) / box.rect.height;
    ox = Math.max(0, Math.min(1, ox));
    oy = Math.max(0, Math.min(1, oy));
    opener._pan = {
      x: (0.5 - ox) * 2 * box.maxX,
      y: (0.5 - oy) * 2 * box.maxY,
    };
    opener.classList.add('is-tracking');
    clamp(opener);
  }

  function zoomOutAll(except) {
    document.querySelectorAll('.product__modal-opener--image.is-zoomed').forEach(function (opener) {
      if (opener !== except) setZoom(opener, false);
    });
  }

  function setZoom(opener, on, origin) {
    var img = imgOf(opener);
    var frame = frameOf(opener);
    var button = buttonOf(opener);
    if (!img || !frame) return;

    if (!on) {
      opener.classList.remove('is-zoomed', 'is-panning', 'is-tracking');
      opener._pan = { x: 0, y: 0 };
      opener._drag = null;
      img.style.transform = '';
      if (button) button.setAttribute('aria-pressed', 'false');
      return;
    }

    zoomOutAll(opener);
    var rect = frame.getBoundingClientRect();
    var ox = origin ? origin.x : 0.5;
    var oy = origin ? origin.y : 0.5;
    var maxX = (rect.width * (SCALE - 1)) / 2;
    var maxY = (rect.height * (SCALE - 1)) / 2;
    opener._pan = {
      x: Math.max(-maxX, Math.min(maxX, (0.5 - ox) * rect.width * (SCALE - 1))),
      y: Math.max(-maxY, Math.min(maxY, (0.5 - oy) * rect.height * (SCALE - 1))),
    };
    opener.classList.add('is-zoomed');
    if (button) button.setAttribute('aria-pressed', 'true');
    clamp(opener);
  }

  function findDragging(id) {
    var list = document.querySelectorAll('.product__modal-opener--image.is-zoomed');
    for (var i = 0; i < list.length; i++) {
      if (list[i]._drag && list[i]._drag.id === id) return list[i];
    }
    return null;
  }

  document.addEventListener(
    'click',
    function (event) {
      var opener = event.target.closest('modal-opener.product__modal-opener--image');
      if (!isProductImage(opener)) return;

      event.preventDefault();
      event.stopPropagation();

      if (opener._suppressClick) {
        opener._suppressClick = false;
        return;
      }

      var onIcon = !!event.target.closest('.product__media-icon');
      var zoomed = opener.classList.contains('is-zoomed');

      if (zoomed) {
        setZoom(opener, false);
        return;
      }

      var frame = frameOf(opener);
      var rect = frame.getBoundingClientRect();
      var origin = onIcon
        ? { x: 0.5, y: 0.5 }
        : {
            x: (event.clientX - rect.left) / rect.width,
            y: (event.clientY - rect.top) / rect.height,
          };
      if (useMouseFollow(event)) opener.classList.add('is-tracking');
      setZoom(opener, true, origin);
    },
    true
  );

  document.addEventListener(
    'pointerup',
    function (event) {
      var icon = event.target.closest('.product__media-icon');
      if (!icon) return;
      var opener = icon.closest('modal-opener.product__modal-opener--image');
      if (!isProductImage(opener) || !opener.classList.contains('is-zoomed')) return;
      event.preventDefault();
      event.stopPropagation();
      opener._suppressClick = true;
      setZoom(opener, false);
    },
    true
  );

  document.addEventListener('pointerdown', function (event) {
    var opener = event.target.closest('modal-opener.product__modal-opener--image');
    if (!isProductImage(opener)) return;
    /* A drag sets this so its own click does not zoom out. The browser often
       never sends that click after preventDefault, which ate the next tap. */
    opener._suppressClick = false;
    if (useMouseFollow(event)) return;
    if (!opener.classList.contains('is-zoomed')) return;
    if (event.target.closest('.product__media-icon')) return;
    if (event.button != null && event.button !== 0) return;
    opener._drag = {
      id: event.pointerId,
      x: event.clientX,
      y: event.clientY,
      px: opener._pan.x,
      py: opener._pan.y,
      moved: false,
    };
  });

  document.addEventListener(
    'pointermove',
    function (event) {
      if (useMouseFollow(event)) {
        var hoverOpener = event.target.closest('modal-opener.product__modal-opener--image');
        if (!isProductImage(hoverOpener) || !hoverOpener.classList.contains('is-zoomed')) return;
        if (event.target.closest('.product__media-icon')) return;
        panToPointer(hoverOpener, event.clientX, event.clientY);
        return;
      }

      var opener = findDragging(event.pointerId);
      if (!opener || !opener._drag) return;
      var dx = event.clientX - opener._drag.x;
      var dy = event.clientY - opener._drag.y;
      if (!opener._drag.moved && Math.hypot(dx, dy) < DRAG_PX) return;
      opener._drag.moved = true;
      opener.classList.add('is-panning');
      opener._pan.x = opener._drag.px + dx;
      opener._pan.y = opener._drag.py + dy;
      clamp(opener);
      if (event.cancelable) event.preventDefault();
    },
    { passive: false }
  );

  function endDrag(event) {
    var opener = findDragging(event.pointerId);
    if (!opener || !opener._drag) return;
    if (opener._drag.moved) opener._suppressClick = true;
    opener.classList.remove('is-panning');
    opener._drag = null;
  }

  document.addEventListener('pointerup', endDrag);
  document.addEventListener('pointercancel', endDrag);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    zoomOutAll(null);
  });

  document.addEventListener('click', function (event) {
    if (!event.target.closest('.thumbnail, .thumbnail-list')) return;
    zoomOutAll(null);
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.product__modal-opener--image.is-zoomed').forEach(clamp);
  });

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () {
      zoomOutAll(null);
    });
  }
})();
